import { formatAppointmentDate, formatAppointmentTime } from "@zapis24/utils";

export type ClientAppointmentSummary =
  | {
      kind: "next";
      startsAt: string;
      serviceName: string;
    }
  | {
      kind: "last";
      startsAt: string;
      serviceName: string;
      status: "COMPLETED";
    };

type FormatOptions = {
  timeZone?: string;
};

export function formatClientAppointmentSummary(
  summary: ClientAppointmentSummary | null,
  options: FormatOptions = {},
): string | null {
  if (!summary) {
    return null;
  }

  const dateText = formatAppointmentDate(summary.startsAt, options.timeZone);

  if (summary.kind === "last") {
    return `Последний визит: ${dateText} · ${summary.serviceName}`;
  }

  const timeText = formatAppointmentTime(summary.startsAt, options.timeZone);

  return `Следующая: ${dateText}, ${timeText} · ${summary.serviceName}`;
}

export function formatClientNotePreview(notes: string | null, maxLength = 64): string | null {
  const normalized = notes?.trim().replace(/\s+/g, " ") ?? "";
  if (!normalized) {
    return null;
  }

  if (normalized.length <= maxLength) {
    return normalized;
  }

  const visibleText = normalized.slice(0, Math.max(0, maxLength - 3)).trimEnd();
  const lastSpaceIndex = visibleText.lastIndexOf(" ");
  const compactText = lastSpaceIndex > 0 ? visibleText.slice(0, lastSpaceIndex) : visibleText;

  return `${compactText}...`;
}
